export const defaultJsBehaviorSrc = `\
/**
 * @param {AgentState} state of the agent
 * @param {AgentContext} context of the agent
 */
const behavior = (state, context) => {

};
`;
